import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=3cfcbdc9"
import script from "./ErrorIcon.vue?vue&type=script&lang=js"
export * from "./ErrorIcon.vue?vue&type=script&lang=js"
import style0 from "./ErrorIcon.vue?vue&type=style&index=0&id=3cfcbdc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports